import React from 'react';
import { Zap } from 'lucide-react';
import './CommonHeader.css';
import { useNavigate, useLocation } from 'react-router-dom';

const CommonHeader = ({ title, description }) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <nav className="landing-nav">
            <div className="logo" onClick={() => navigate('/')}>
                <Zap className="logo-icon" fill="#6366f1" color="#6366f1" />
                <span>Knolup</span>
            </div>
            <div className="nav-actions">
                {location.pathname !== '/login' && (
                    <button className="btn-primary-no-border" onClick={() => navigate('/login')}>
                        Login
                    </button>
                )}
                <button className="btn-primary-rounded" onClick={() => navigate('/register')}>
                    Join Now
                </button>
                {location.pathname !== '/pricing' && (
                    <button className="btn-accent hide-mobile" onClick={() => navigate('/pricing')}>
                        Pricing
                    </button>
                )}
            </div>
        </nav>
    );
};

export default CommonHeader;